import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import ModalConsent from './ModalConsent';
import ListConsents from './ListConsents';
import ListConsentActions from './ListConsentActions';

/*
import ListExcludeInclude from './ListExcludeInclude';
import ListExcludeIncludeActions from './ListExcludeIncludeActions';
*/

import Spinner from 'react-bootstrap/Spinner';

import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';


const InformedConsent = ({ location }) => {
    const history = useHistory();
    let feasibility = location.state;

    const [consents,setConsents] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [openModalConsent, setOpenModalConsent] = useState(false);

    useEffect(() => {
        listConsents();
    }, []);

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const doOpenModalConsent = () => {
        setOpenModalConsent(true);
    }

    const doCloseModalConsent = () => {
        setOpenModalConsent(false)
    }

    const listConsents = () => 
    {
        fetch(`${process.env.REACT_APP_PUBLIC_URL}consentimiento-informado/listar?id_estudio=`+location.state.id_estudio, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            let consentsData = [];
            for(let i = 0;i<data.length;i++) 
            {
                data[i].feasibility = location.state;
                consentsData.push(data[i]);
            }

            setConsents(consentsData);
        }).catch(err => {
            setConsents([]);
        });
    }
    
    const ConsentsList = () => {
        
        return (
            <ListConsents reactTableData={consents} ReactTableActions={ListConsentActions} />
        );
        
    }

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Consentimiento Informado</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>

                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>

                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="text-center">
                        {
                            <Button onClick={doOpenModalConsent} className="btn btn-primary btn-sm text-white">
                                Agregar
                            </Button>
                        }
                        
                    </div>
                    <Row>

                        {isLoading &&
                            <div className="text-center">
                                <Spinner animation="border" variant="success" />
                            </div>
                        }

                        <Container>
                            <ConsentsList/>
                        </Container>

                    </Row>
                </CardBody>
            </Card>

            <ModalConsent
            feasibility={location.state}
            listConsents={listConsents}
            doCloseModalConsent={doCloseModalConsent}
            opened={openModalConsent}
            
            />

        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_criterial_excinc', // a unique identifier for this form
})(InformedConsent);